/**
 * 认证相关的工具函数
 */

import authState from './authState';

/**
 * 获取包含认证令牌的请求头
 * @returns {Object} 包含认证令牌的请求头对象
 */
export const getAuthHeaders = () => {
  const headers = {};
  
  // 从authState获取令牌
  const token = authState.token.value;
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

/**
 * 检查用户是否已登录
 * @returns {boolean} 用户是否已登录
 */
export const isAuthenticated = () => {
  return authState.isLoggedIn.value;
};

/**
 * 检查用户是否为管理员
 * @returns {boolean} 用户是否为管理员
 */
export const isAdmin = () => {
  return authState.isAdmin.value;
};

export default {
  getAuthHeaders,
  isAuthenticated,
  isAdmin
}; 